import { ArbitrumIcon } from "shared/src/icons/crypto/ArbitrumIcon";
import { BCHIcon } from "shared/src/icons/crypto/BCHIcon";
import { BitcoinIcon } from "shared/src/icons/crypto/BitcoinIcon";
import { BNBIcon } from "shared/src/icons/crypto/BNBIcon";
import { BaseIcon } from "shared/src/icons/crypto/BaseIcon";
import { EtheriumIcon } from "shared/src/icons/crypto/EtheriumIcon";
import { SOLIcon } from "shared/src/icons/crypto/SOLIcon";
import { TronIcon } from "shared/src/icons/crypto/TronIcon";
import { RadixQuestionMarkIcon } from "shared/src/icons/RadixQuestionMarkIcon";

export const CryptoNetworkIcon = ({
  network,
  className,
}: {
  network?: string;
  className?: string;
}) => {
  const iconClassName = className ?? "size-6";

  switch (network?.toLowerCase()) {
    case "eth":
    case "erc20":
    case "ethereum":
      return <EtheriumIcon className={iconClassName} />;
    case "sol":
    case "solana":
      return <SOLIcon className={iconClassName} />;
    case "bch":
      return <BCHIcon className={iconClassName} />;
    case "btc":
    case "bitcoin":
      return <BitcoinIcon className={iconClassName} />;
    case "binance":
      return <BNBIcon className={iconClassName} />;
    case "base":
      return <BaseIcon className={iconClassName} />;
    case "arbitrum":
      return <ArbitrumIcon className={iconClassName} />;
    case "trc20":
    case "tron":
      return <TronIcon className={iconClassName} />;
    default:
      return null;
  }
};
